import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function useAuditLog(filters = {}) {
    return useQuery({
        queryKey: ['audit-log', filters],
        queryFn: () => {
            const params = new URLSearchParams();
            if (filters.action)
                params.set('action', filters.action);
            if (filters.dateFrom)
                params.set('date_from', filters.dateFrom);
            if (filters.dateTo)
                params.set('date_to', filters.dateTo);
            if (filters.limit)
                params.set('limit', String(filters.limit));
            if (filters.offset)
                params.set('offset', String(filters.offset));
            const qs = params.toString();
            return apiClient(`/audit-log${qs ? `?${qs}` : ''}`);
        },
        staleTime: 1000 * 30,
    });
}
//# sourceMappingURL=useAuditLog.js.map